import React, { useEffect, useState, useMemo } from "react"
import moment from "moment"
import Loader from "components/Loader"
import { useSelector } from "react-redux"
import { get, isEmpty } from "lodash"
import { getTeamsBlockOutList } from "requesters/userRequester"
import { getBaseUrl } from "../apps/App/reducers"

const UserBlockOutTable = ({
  byTeams, startTime, endTime
}) => {
  const baseUrl = useSelector(getBaseUrl)
  const [requesting, setRequesting] = useState(false)
  const [blockOuts, setBlockOuts] = useState([])

  const fetchBlockOutsData = () => {
    setRequesting(true)
    const payload = {
      by_teams: byTeams,
      start_at: startTime,
      end_at: endTime
    }
    getTeamsBlockOutList(baseUrl, payload)
    .then(res => {
      if (res.status === 200) {
        const blockOutsData = get(res.response, "userBlockOut", {});
        const newBlockOuts = Object.values(blockOutsData);
        setBlockOuts(newBlockOuts)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  useEffect(() => {
    fetchBlockOutsData()
  }, [byTeams])

  const sortedBlockOuts = useMemo(() => {
    if (!blockOuts?.length) return []

    return [...blockOuts].sort((a, b) => {
      const startTimeA = moment(a.attributes?.startAt, "DD/MM/YYYY hh:mm A")
      const startTimeB = moment(b.attributes?.startAt, "DD/MM/YYYY hh:mm A")
      return startTimeA.valueOf() - startTimeB.valueOf()
    })
  }, [blockOuts])

  const noData = isEmpty(sortedBlockOuts)

  return (
    <div className="mb-2">
      <div className="d-flex align-items-center mt-3 mb-0">
        <h5 className="mb-0 mr-2 d-inline">Scheduled Leave</h5>
        <button
          type="button"
          className="btn btn-link p-0 ms-2"
          onClick={fetchBlockOutsData}
          disabled={requesting}
          title="Refresh data">
          <i className="bi bi-arrow-repeat"></i>
        </button>
      </div>
      { requesting ? <Loader />
      : (
        <div className="table-responsive">
          { noData && (
            <div className="mt-2 py-2 bg-light-gray d-flex justify-content-center align-items-center">
              <h6 className="mb-0">No Ongoing Leave</h6>
            </div>
          )}
          { !noData && (
            <table className="table table-listing table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>Leave Type</th>
                  <th>Start At</th>
                  <th>End At</th>
                </tr>
              </thead>
              <tbody>
                {
                  sortedBlockOuts.map(bo => {
                    const startTime = moment(bo.attributes?.startAt, "DD/MM/YYYY hh:mm A")
                    const endTime = moment(bo.attributes?.endAt, "DD/MM/YYYY hh:mm A")

                    return (
                      <tr key={bo?.id}>
                        <td>{bo.attributes?.userName}</td>
                        <td>{bo.attributes?.leaveType}</td>
                        <td>{startTime.format("DD/MM/YYYY hh:mm A")}</td>
                        <td>{endTime.format("DD/MM/YYYY hh:mm A")}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  )
}

export default UserBlockOutTable